module.exports = __webpack_public_path__ + "img/10.0c2af926.jpg";